import type { PurchaseOrderDetailsDto } from "../../../../api";
import { OrderHeader } from "../../../../components/common/order-header";

interface PurchaseOrderHeaderProps {
  purchaseOrder: PurchaseOrderDetailsDto;
  isInDelivery?: boolean;
  isDelivered?: boolean;
  deliveredAt?: string | null;
  actions?: React.ReactNode;
}

export function PurchaseOrderHeader({
  purchaseOrder,
  isInDelivery = false,
  isDelivered = false,
  deliveredAt,
  actions,
}: PurchaseOrderHeaderProps) {
  const buyerReceived =
    purchaseOrder.dropshipping?.some((d) => d.confirmedByBuyer) ?? false;

  return (
    <OrderHeader
      name={purchaseOrder.name}
      state={purchaseOrder.state}
      dateOrder={purchaseOrder.dateOrder}
      datePlanned={purchaseOrder.datePlanned}
      isInDelivery={isInDelivery}
      isDelivered={isDelivered}
      deliveredAt={deliveredAt}
      buyerReceived={buyerReceived || null}
      actions={actions}
    />
  );
}
